import API from 'services/api';

export const unregisterPushNotification = (
  data: { endpoint: string; keys: { p256dh: string; auth: string } } | { deviceToken: string },
) => API.post('/api/notifications/unregister-push', data, { timeout: 5000 });
